export default __webpack_public_path__ + "static/media/logo1-white.1f8a5e35.png";